import { render } from "./BlogView.vue?vue&type=template&id=47b37518"
const script = {}

import exportComponent from "/home/runner/work/PIPIPIG233666.github.io/PIPIPIG233666.github.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__